export default __webpack_public_path__ + "static/media/arrowCollapse.2f752288.svg";